import React, { useEffect, useState } from "react";
import OrderTable from "./OrderTable";
import MessageSentTable from "./MessageSentTable";
import ColdCall from "./ColdCall";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button, DatePicker } from "antd";
import { userCallings } from "./store";
import ProductivityStats from "./ProductivityStats";
import MedAgent from "./MedAgent";
import { toast } from "react-toastify";
import moment from "moment";
import { currentUser } from "modules/utilities/utility";
import { quotes } from "modules/utilities/utility_2";
import secureLocalStorage from "react-secure-storage";

function ProductivityDashboard() {
  const momentDate = moment().format("YYYY-MM-DD");
  const currentUserLevel = secureLocalStorage.getItem("level");
  const restrictedLevel = ["1", "2"];
  const [selectedMedAgent, setSelectedMedAgent] = useState();
  const [dateFilter, setDateFilter] = useState(momentDate);
  const accessFlag = ["medical_rep"];
  const {
    getCallingData,
    callingData,
    getAuditData,
    callingAuditData,
    coachWabaData,
    isLoading,
    coachWabaLoading,
    getCoachWabaData,
    getCoachOrderData,
    orderCoachData,
    orderCoachLoading,
  } = userCallings();

  useEffect(() => {
    getCallingData();
  }, []);

  useEffect(() => {
    getAuditData();
    // getCoachWabaData();
    getCoachOrderData();
  }, []);

  const handleSubmit = () => {
    let medAgentParam = selectedMedAgent;
    let dateParam = dateFilter;
    if (!dateFilter && !selectedMedAgent) {
      toast.warning("Please Select Filter");
      return;
    }
    if (!dateFilter) {
      dateParam = null;
    }
    if (!selectedMedAgent) {
      medAgentParam = null;
    }
    getAuditData(medAgentParam, dateParam);
    getCoachWabaData(medAgentParam, dateParam);
    getCoachOrderData(medAgentParam, dateParam);
  };

  const handleClear = () => {
    setSelectedMedAgent(null);
    setDateFilter(momentDate);
    getAuditData();
    getCoachWabaData();
    getCoachOrderData();
  };

  const handleDate = (date, dateString) => {
    setDateFilter(dateString);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="fs-2 text-nowrap pe-2"
            style={{ fontFamily: "poppins" }}
          >
            {!accessFlag.includes(currentUser) ? (
              <span>Productivity Dashboard</span>
            ) : null}
            👋 Hi {secureLocalStorage.getItem("first_name")}
          </div>
          <marquee className="text-primary px-2" style={{ width: "40rem" }}>
            {quotes[Math.floor(Math.random() * quotes.length)]}
          </marquee>
          <div className="d-flex gap-2 ps-2">
            {(currentUser == "medical_rep" &&
              !restrictedLevel.includes(currentUserLevel)) ||
            currentUser !== "medical_rep" ? (
              <MedAgent
                callingData={callingData}
                selectedMedAgent={selectedMedAgent}
                setSelectedMedAgent={setSelectedMedAgent}
              />
            ) : null}
            <DatePicker onChange={handleDate} />
            <Button type="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button type="primary" onClick={handleClear}>
              Clear
            </Button>
          </div>
        </div>
      }
      component={
        <div>
          <div className="w-100 h-100 d-flex flex-column gap-2 mt-n2">
            <ProductivityStats callingData={callingAuditData} />
            <div className="d-flex flex-row gap-2 mt-n2">
              <div className="card mb-2" style={{ width: "60%" }}>
                <OrderTable
                  orderCoachData={orderCoachData}
                  loading={orderCoachLoading}
                />
              </div>
              <div className="mb-2 card" style={{ width: "40%" }}>
                {/* <MessageSentTable
                  coachWabaData={coachWabaData}
                  loading={coachWabaLoading}
                /> */}
              </div>
            </div>
            <div className="d-flex gap-2 flex-row">
              <div className="card p-2 mb-2 mt-n2" style={{ width: "100%" }}>
                {/* <div className="fs-1 p-2 border-bottom fw-bold">
                  Calling Related Data
                </div> */}
                <ColdCall callingData={callingAuditData} loading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default ProductivityDashboard;
